export enum EnumAutomationAction {
  Activate = 'activate',
  Pause = 'pause',
  RunNow = 'run_now',
  Edit = 'edit',
  Delete = 'delete'
}
